import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const getUrlResolvers = createAction(
  'GET_URL_RESOLVERS',
  () => api.get('url_resolvers').setCritical(false)
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/url-resolvers.js